import { defineStore } from 'pinia'
import { getContentPage } from '@/services/contentService'
import { getCategoryDetailsById, getCategoryDetailsBySlug } from '@/services/categoryService'
import { getProjectsByCategoryId, getProjectsBySubCategory } from '@/services/projectService'

export const useServiceStore = defineStore('service', {
  state: () => ({
    details: {},
    content1: {},
    content2: {},
    content3: {},
    content4: {},
    projects: [],
    loading: false,
    error: null
  }),

  actions: {
    async fetchCategoryDetailsBySlug(slug) {
      this.loading = true
      this.error = null

      try {
        const baseUploadURL = process.env.VUE_APP_API_URL;
        const detailsContent = await getCategoryDetailsBySlug(slug)
        const servicesContent = await getContentPage('Services', 'Item Content')
        const projectListByCategoryId = await getProjectsByCategoryId(detailsContent?.id, 1, 10)
        
        console.log(projectListByCategoryId)
        detailsContent.banner = detailsContent.banner ? baseUploadURL + detailsContent.banner.uploadFile : null

        const mapServicesContent = await Promise.all(
          servicesContent.map(async item => ({
            ...item,
            image: item.banner
              ? baseUploadURL + item.banner.uploadFile
              : null,
          }))
        )
        
        const mapProjectList = await Promise.all(
          projectListByCategoryId.docs.map(async item => ({
            ...item,
            image: item.coverBanner
              ? baseUploadURL + item.coverBanner.uploadFile
              : null,
            thumbs: item.thumbnails
              ? baseUploadURL + item.thumbnails.uploadFile
              : null,

            categoryId: {
              ...item.categoryId,

              parentId:
                item?.categoryId?.parentId !== null
                  ? await getCategoryDetailsById(item?.categoryId?.parentId)
                  : null
            }
          }))
        )

        this.details = detailsContent
        this.content1 = mapServicesContent[0]
        this.content2 = mapServicesContent[1]
        this.content3 = mapServicesContent[2]
        this.content4 = mapServicesContent[3]
        this.projects = mapProjectList
        console.log(detailsContent)
        console.log(mapProjectList)
      } catch (err) {
        this.error = err.message
      } finally {
        this.loading = false
      }
    },
    async fetchCategoryDetailsBySubSlug(subSlug) {
      this.loading = true
      this.error = null

      try {
        const baseUploadURL = process.env.VUE_APP_API_URL;
        const detailsContent = await getCategoryDetailsBySlug(subSlug)
        const servicesContent = await getContentPage('Services', 'Item Content')
        const projectListByCategoryId = await getProjectsBySubCategory(detailsContent?.id, 1, 10)
        
        console.log(projectListByCategoryId)
        detailsContent.banner = detailsContent.banner ? baseUploadURL + detailsContent.banner.uploadFile : null

        const mapServicesContent = await Promise.all(
          servicesContent.map(async item => ({
            ...item,
            image: item.banner
              ? baseUploadURL + item.banner.uploadFile
              : null,
          }))
        )
        
        const mapProjectList = await Promise.all(
          projectListByCategoryId.docs.map(async item => ({
            ...item,
            image: item.coverBanner
              ? baseUploadURL + item.coverBanner.uploadFile
              : null,
            thumbs: item.thumbnails
              ? baseUploadURL + item.thumbnails.uploadFile
              : null,

            categoryId: {
              ...item.categoryId,

              parentId:
                item?.categoryId?.parentId !== null
                  ? await getCategoryDetailsById(item?.categoryId?.parentId)
                  : null
            }
          }))
        )

        this.details = detailsContent
        this.content1 = mapServicesContent[0]
        this.content2 = mapServicesContent[1]
        this.content3 = mapServicesContent[2]
        this.content4 = mapServicesContent[3]
        this.projects = mapProjectList
        console.log(detailsContent)
        console.log(mapProjectList)
      } catch (err) {
        this.error = err.message
      } finally {
        this.loading = false
      }
    }
  }
})